import React from "react";
import Navigation from "@/components/Navigation";
import WhatsAppButton from "@/components/WhatsAppButton";
import Hero from "@/components/Hero";
import StatsCounter from "@/components/StatsCounter";
import ProductsSection from "@/components/ProductsSection";
import WhyChooseUs from "@/components/WhyChooseUs";

import PerformanceSection from "@/components/PerformanceSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import SustainabilitySection from "@/components/SustainabilitySection";
import AppointmentSection from "@/components/AppointmentSection";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <Hero />
      <StatsCounter />
      <ProductsSection />
      <WhyChooseUs />
      
      <PerformanceSection />
      <TestimonialsSection />
      <SustainabilitySection />
      <AppointmentSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Index;
